import * as React from "react";
import Svg, { Path, Defs, ClipPath, Rect, G, Use } from "react-native-svg";
const NonAcademicIcon = (props) => (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <G clipPath="url(#clip0_7904_1454)">
            <Use xlinkHref="#stroke0_7904_1454" fill={props?.customColor ?? "black"} />
            <Use xlinkHref="#stroke0_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke0_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke0_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke1_7904_1454" fill={props?.customColor ?? "black"} />
            <Use xlinkHref="#stroke1_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke1_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke1_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke2_7904_1454" fill={props?.customColor ?? "black"} />
            <Use xlinkHref="#stroke2_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke2_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Use xlinkHref="#stroke2_7904_1454" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
        </G>
        <Defs>
            <ClipPath id="clip0_7904_1454">
                <Rect width="24" height="24" fill="white" />
            </ClipPath>
            <Path id="stroke0_7904_1454" d="M12 2L6.5 11H17.5L12 2Z" />
            <Path id="stroke1_7904_1454" d="M17.5 22C19.9853 22 22 19.9853 22 17.5C22 15.0147 19.9853 13 17.5 13C15.0147 13 13 15.0147 13 17.5C13 19.9853 15.0147 22 17.5 22Z" />
            <Path id="stroke2_7904_1454" d="M3 13.5H11V21.5H3V13.5Z" />
        </Defs>
    </Svg>
);
export default NonAcademicIcon;
